export const isWebHidSupportedInBrowser = (): boolean =>
  typeof window.navigator.hid !== 'undefined';
